import {createFeatureSelector, createSelector} from '@ngrx/store';
import { IGreenIdState } from './state';
import { CIRTState } from '../../store/cirt.states';
import { featureKey } from './../../store/cirt.reducers';

export const uiComponentState = createFeatureSelector<CIRTState>(featureKey);
export const state = createSelector(uiComponentState, (state) => state.greenIdState);

export const greenId_Model = createSelector(
    state,
    (state: IGreenIdState) => state.model
);

export const greenId_IsLoading = createSelector(
    state,
    (state: IGreenIdState) => state.isLoading
);

export const greenId_SubmittedDate = createSelector(
    state,
    (state: IGreenIdState) => state.submittedDate
);

export const greenId_ScriptLoaded = createSelector(
    state,
    (state: IGreenIdState) => state.scriptLoaded
);

export const greenId_MemberData = createSelector(
    state,
    (state: IGreenIdState) => state.member
);

export const greenId_ConsentForm = createSelector(
    state,
    (state: IGreenIdState) => state.consentForm
);

export const greenId_ConsentSaving = createSelector(
    state,
    (state: IGreenIdState) => state.consentSaving
);

export const greenId_ConsentError = createSelector(
    state,
    (state: IGreenIdState) => state.consentError
);

export const greenId_ConsentCompletedDate = createSelector(
    state,
    (state: IGreenIdState) => state.consentCompletedDate
);
